module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo19-b03b84bbc938a596b495fe585751a990.jpg";